import { Controller } from '@hotwired/stimulus';
import {
  getPreference,
  setPreference,
  type ThemePreference,
} from '../lib/theme';

interface SelectEvent extends Event {
  params: { value: ThemePreference };
}

// Choix d'apparence de la navbar serveur : bouton des pages anonymes
// (ThemeMenuComponent), ligne du menu du compte (ThemeChoiceComponent). Le serveur
// le rend dans l'état du cookie ; `reflect`, branché sur `themechange`, le réaligne
// quand la préférence change, par ce choix ou au retour arrière.
export default class extends Controller {
  static targets = ['option', 'current'];

  declare readonly optionTargets: HTMLElement[];

  declare readonly currentTargets: HTMLElement[];

  // eslint-disable-next-line class-methods-use-this
  select({ params }: SelectEvent): void {
    setPreference(params.value);
  }

  reflect(): void {
    const preference = getPreference();

    this.optionTargets.forEach((option) => {
      const chosen = option.dataset.themeValueParam === preference;
      option.setAttribute('aria-pressed', String(chosen));
    });

    this.currentTargets.forEach((current) => {
      // eslint-disable-next-line no-param-reassign
      current.hidden = current.dataset.preference !== preference;
    });
  }
}
